export default "__VITE_ASSET__BQEFZHyz__"